import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Context } from 'features/app/types';

/**
 ** Initial State
 */
const initialState: StandardPage.State = {
	gpSelectorIsOpen: false,
	userProfileIsOpen: false,
	rtmMessagingIsOpen: false,
};

/**
 ** Standard Page Slice
 */
const standardPage = createSlice({
	name: 'standardPage',
	initialState,
	reducers: {
		toggleGpSelector(state, action: PayloadAction<boolean>) {
			return {
				...state,
				gpSelectorIsOpen: action.payload,
			};
		},
		toggleUserProfile(state, action: PayloadAction<boolean>) {
			return {
				...state,
				userProfileIsOpen: action.payload,
			};
		},
		toggleRtmMessaging(state, action: PayloadAction<boolean>) {
			return {
				...state,
				rtmMessagingIsOpen: action.payload,
			};
		},
	},
});

/**
 ** Export Actions
 */
export const { toggleGpSelector, toggleUserProfile, toggleRtmMessaging } = standardPage.actions;

/**
 ** Export Selectors
 */
export const getGpSelectorState = ({ standardPage }: RootState) => standardPage.gpSelectorIsOpen;
export const getUserProfileState = ({ standardPage }: RootState) => standardPage.userProfileIsOpen;
export const getRtmMessagingState = ({ standardPage }: RootState) =>
	standardPage.rtmMessagingIsOpen;

/**
 * Get group access settings to determine which primary nav should be displayed -
 * Summit or Connect
 */
export const getGroupAccessSettingsForNavigation = ({ context }: RootState): boolean => {
	const hasGroupAccess = context.client?.hasGroupAccess ?? false;

	return hasGroupAccess;
};

/**
 ** Export Reducers
 */
export default standardPage.reducer;
